import * as React from 'react';
import { useState } from "react";
import { IoMdNotifications } from "react-icons/io";
import { IoArrowBack } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { styled } from '@mui/material/styles';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#2972FE',
        ...(theme.applyStyles ? theme.applyStyles('dark', { backgroundColor: '#177ddc' }) : {}),
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: '#9098A1',
    boxSizing: 'border-box',
    ...(theme.applyStyles ? theme.applyStyles('dark', { backgroundColor: 'rgba(255,255,255,.35)' }) : {}),
  },
}));

function Notification() {
  const [sound, setSound] = useState(true);
  const [vibrate, setVibrate] = useState(false);
  const [tips, setTips] = useState(true);
  const [service, setService] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#130828] flex flex-col items-center py-8 px-4">
      {/* Back Button */}
      <button
        className="absolute left-4 top-6 flex items-center gap-2 text-[#6499FF] hover:text-white transition text-lg"
        onClick={() => navigate(-1)}
        aria-label="Go back"
      >
        <IoArrowBack size={24} color="#fff" />
      </button>
      <h2 className="text-white text-xl font-bold mb-8">Notifications</h2>
      <div className="w-full max-w-md  rounded-2xl p-6 shadow-lg">
        <FormGroup>
          <FormControlLabel
            control={<AntSwitch checked={sound} onChange={() => setSound(v => !v)} />}
            label={<span className="text-white text-base font-medium">Sound</span>}
            className="flex justify-between mb-4"
            labelPlacement="start"
          />
          <hr className="border-gray-600 mb-4" />
          <FormControlLabel
            control={<AntSwitch checked={vibrate} onChange={() => setVibrate(v => !v)} />}
            label={<span className="text-white text-base font-medium">Vibrate</span>}
            className="flex justify-between mb-4"
            labelPlacement="start"
          />
           <hr className="border-gray-600 mb-4" />
          <FormControlLabel
            control={<AntSwitch checked={tips} onChange={() => setTips(v => !v)} />}
            label={<span className="text-white text-base font-medium">New tips available</span>}
            className="flex justify-between mb-4"
            labelPlacement="start"
          />
           <hr className="border-gray-600 mb-4" />
          <FormControlLabel
            control={<AntSwitch checked={service} onChange={() => setService(v => !v)} />}
            label={<span className="text-white text-base font-medium">New service available</span>}
            className="flex justify-between"
            labelPlacement="start"
          />
        </FormGroup>
      </div>
    </div>
  );
}

export default Notification;
